import { createContext, useEffect, useState } from 'react';
import { Tariff, TariffsResponse, TariffResponse, CountriesResponse, Country, CatalogTariffResponse, Catalog, PaymentType } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type TariffsContextProps = {
    tariffs: Tariff[];
    channels: Catalog[];
    currencies: Catalog[];
    banks: Catalog[];
    brands: Catalog[];
    paymentTypes: PaymentType[];
    totalPage: number;
    loadTariffs: (merchantId: number, page: number) => Promise<void>;
    loadCatalogs: () => Promise<void>;
    addTariff: (tariff: Tariff) => Promise<string>;
    updateTariff: (tariff: Tariff) => Promise<string>;
    deleteTariff: (tariff: Tariff) => Promise<string>;

}



export const TariffsContext = createContext({} as TariffsContextProps);

export const TariffsProvider = ({ children }: any) => {

    const [tariffs, setTariffs] = useState<Tariff[]>([]);
    const [channels, setChannels] = useState<Catalog[]>([]);
    const [currencies, setCurrencies] = useState<Catalog[]>([]);
    const [banks, setBanks] = useState<Catalog[]>([]);
    const [brands, setBrands] = useState<Catalog[]>([]);
    const [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([]);

    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    const loadCatalogs = async () => {

        const resp = await topApi.get<CatalogTariffResponse>('/tariff/getCatalogsForTariffs');
        if (resp.status == 200) {
            setChannels(resp.data.channels);
            setCurrencies(resp.data.currencies);
            setBanks(resp.data.banks);
            setBrands(resp.data.brands);
            setPaymentTypes(resp.data.paymentTypes);
            setTotalPage(1);
        }


    }


    const loadTariffs = async (merchantId, pageActual) => {

        const resp = await topApi.get<TariffsResponse>('/tariff/getTariffs/' + merchantId);
        if (resp.status == 200) {
            setTariffs([...resp.data.tariffs]);
            setTotalPage(1);
        }


    }

    const addTariff = async (tariff: Tariff) => {
        try {

            const resp = await topApi.post<TariffResponse>('/tariff/', { tariff });
            setTariffs([...tariffs, resp.data.tariff]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateTariff = async (tariff: Tariff) => {
        try {
            const resp = await topApi.put<Tariff>(`/tariff/`, { tariff });

            setTariffs(tariffs.map(prod => {
                return (
                    prod.merchantId === tariff.merchantId &&
                    prod.paymentTypeId === tariff.paymentTypeId &&
                    prod.brandId === tariff.brandId &&
                    prod.bankId === tariff.bankId &&
                    prod.currencyId === tariff.currencyId &&
                    prod.channelId === tariff.channelId
                )
                    ? resp.data["tariff"]
                    : prod;
            }));


            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteTariff = async (tariff: Tariff) => {
        try {
            await topApi.post<Tariff>(`/tariff/delete`, { ...tariff });
            setTariffs((prevTariffs) =>
                prevTariffs.filter((prod) =>
                    !(
                        prod.merchantId === tariff.merchantId &&
                        prod.paymentTypeId === tariff.paymentTypeId &&
                        prod.brandId === tariff.brandId &&
                        prod.bankId === tariff.bankId &&
                        prod.currencyId === tariff.currencyId &&
                        prod.channelId === tariff.channelId
                    )
                )
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }



    return (
        <TariffsContext.Provider value={{
            tariffs, channels,
            currencies,
            banks,
            brands,
            paymentTypes, totalPage, loadTariffs, addTariff, updateTariff, deleteTariff, loadCatalogs
        }}>
            {children}
        </TariffsContext.Provider>
    );
}